import { createAction } from 'redux-actions'

import { CLEAR_EXPORT, CUSTOMER_COOKIE, EXPORT, FETCH_CURRENT_USER } from 'constants/app-constants'
import { createCookie, getCookie } from 'utils/cookies'
import { get } from 'utils/http'
import { navigate } from 'utils/navigation'

const noop = () => {}

const fetchCurrentUserAction = createAction(`${FETCH_CURRENT_USER}_SUCCESS`)

export const fetchCurrentUser =
  (p: any = {}, redirect = noop, errorPath = '/register') =>
  async (d, getState) => {
    if (p.customerId) createCookie(CUSTOMER_COOKIE, p.customerId)

    const authenticated = getState().auth.authenticated

    if (!authenticated) return

    try {
      const customerId = getCookie(CUSTOMER_COOKIE)

      const currentUser = await get(`/customers/${customerId}/current_data`)

      d(fetchCurrentUserAction({ body: currentUser }))
      redirect()
      return currentUser
    } catch (_e) {
      if (p.doNotRedirectUnauthenticatedUser) {
        d(fetchCurrentUserAction({ body: null }))
      } else {
        navigate(errorPath, { replace: true })
      }
      return null
    }
  }

export const exportFile = createAction(EXPORT)

export const clearExport = createAction(CLEAR_EXPORT)
